export default "__VITE_ASSET__CyDEBMOr__"